import React, { ComponentType, HTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from '@/components/icons/Logo';
import Company from '@/components/icons/Company';
import LeftSide from '@/components/LeftSide';
import RightSide from '@/components/RightSize';

export type Props = PropsWithChildren & {
  logo?: ReactNode;
  'right-children'?: ReactNode,
  'left-children'?: ReactNode,
};

const StyledHeader: ComponentType<HTMLAttributes<HTMLElement>> = styled('header')(() => `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  height: 60px;
  padding: 0px 20px;
  background-color: #fff;
`);

export default ({ children, logo, 'left-children': leftChildren, 'right-children': rightChildren, ...props }: Props) => (
  <StyledHeader {...props}>
    <LeftSide style={{ width: '0px', overflowX: 'visible' }}>
      <Link to="/" style={{ display: 'block', textWrap: 'nowrap' }}>
        {logo || (
          <>
            <Logo style={{ color: '#0052CC', width: '30px', height: '33px', lineHeight: '33px', verticalAlign: 'middle' }} />
            <Company style={{ color: '#091E42', width: '70px', height: '12px', lineHeight: '33px', marginLeft: '7px', verticalAlign: 'middle' }} />
          </>
        )}
      </Link>
      {leftChildren}
    </LeftSide>
    {children}
    <RightSide style={{ width: '0px', overflowX: 'visible' }}>
      {rightChildren}
    </RightSide>
  </StyledHeader>
);
